export const getDefaultPermissions = (fileImport) => {
    return {
        read: {
            accountIds: [],
            organizationIds: [],
            systemRoles: [],
        },
        write: {
            accountIds: [],
            organizationIds: [],
            systemRoles: [],
        },
        modify: {
            accountIds: [],
            organizationIds: [],
            systemRoles: [],
        },
        public: !!fileImport,
    };
};
